// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"ForgotPassword__wrapper___3r_Cj","logo":"ForgotPassword__logo___uw0mv","link":"ForgotPassword__link___3j6Ri","button":"ForgotPassword__button___23pPl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ForgotPassword/ForgotPassword.scss
// module id = PFgG
// module chunks = 0